import styled from "styled-components";

export const ContentLayout = styled.main`
    display: grid;
    grid-auto-flow: row;
    align-content: start;
`;
